<template>
    <div class="container mx-auto px-4">
        <debug-overview></debug-overview>
    </div>
</template>
<script>
import DebugOverview from '../components/debug/DebugOverview'

export default {
  name: 'DebugPage',
  components: {
    'debug-overview': DebugOverview
  },

  activated () {
    document.body.classList.remove('overflow-hidden')
  },

  deactivated () {
    document.body.classList.add('overflow-hidden')
  }
}
</script>
